<div class="container py-5">
  <div class="row justify-content-center">
    <div class="col-md-6">
      <div class="card shadow border-0 rounded-4">
        <div class="card-body p-4">
          <div class="text-center mx-auto py-3">
            <a class="navbar-brand" routerLink="/"><img [src]="logoUrl" [alt]="logoAlt" height="60" /></a>
          </div>
          <h3 class="mb-4 text-center">Create Your Account</h3>
          <div class="alert alert-danger" role="alert" *ngIf="errorMessage()">
            <i class="bi bi-exclamation-circle me-2"></i>{{ errorMessage() }}
          </div>
          <div class="alert alert-warning" *ngIf="!appSettingsService.registrationEnabled()">
            Registration is currently disabled by the administrator. Please try again later.
          </div>
          <form (ngSubmit)="onRegister()" [formGroup]="registerForm">
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="firstName" class="form-label">First Name</label>
                <input type="text" formControlName="firstName" class="form-control" id="firstName" placeholder="First name" autocomplete="given-name">
              </div>
              <div class="col-md-6 mb-3">
                <label for="lastName" class="form-label">Last Name</label>
                <input type="text" formControlName="lastName" class="form-control" id="lastName" placeholder="Last name" autocomplete="family-name">
              </div>
            </div>
            <div class="mb-3">
              <label for="email" class="form-label">Email address</label>
              <input type="email" formControlName="email" class="form-control" id="email" placeholder="you@boatmail.com" autocomplete="email">
            </div>
            <div class="mb-3">
              <label for="password" class="form-label">Password</label>
              <input type="password" formControlName="password" class="form-control" id="password" autocomplete="new-password">
            </div>
            <div class="mb-3">
              <label for="confirmPassword" class="form-label">Confirm Password</label>
              <input type="password" formControlName="confirmPassword" class="form-control" id="confirmPassword" autocomplete="new-password">
            </div>
            <div class="form-check mb-3">
              <input type="checkbox" formControlName="acceptedLegal" class="form-check-input" id="acceptedLegal">
              <label class="form-check-label" for="acceptedLegal">
                I agree to the
                <a routerLink="/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>
                and
                <a routerLink="/terms-and-conditions" target="_blank" rel="noopener">Terms and Conditions</a>.
              </label>
            </div>
            <button type="submit" class="btn btn-primary w-100" [disabled]="registerForm.invalid || !appSettingsService.registrationEnabled() || isSubmitting()">
              <span class="spinner-border spinner-border-sm me-2" aria-hidden="true" *ngIf="isSubmitting()"></span>
              Create account
            </button>
          </form>
          <div class="auth-divider my-4"><span>or</span></div>
          <button
            type="button"
            class="btn btn-outline-secondary w-100 d-flex align-items-center justify-content-center gap-2"
            (click)="onGoogleSignIn()"
            [disabled]="!registerForm.controls['acceptedLegal'].value || !appSettingsService.registrationEnabled() || isSubmitting()">
            <i class="bi bi-google google-mark" aria-hidden="true"></i>
            Continue with Google
          </button>
          <p class="small text-muted text-center mt-2 mb-0" *ngIf="!registerForm.controls['acceptedLegal'].value">
            Accept the Privacy Policy and Terms first to continue with Google.
          </p>
          <div class="text-center mt-3">
            <small>Already have an account? <a routerLink="/login" [queryParams]="registerLinkQueryParams">Sign in</a></small>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
